import { DashboardExperiments } from '@/experiments'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { PremiumFeatures } from '@/services/types/premiumFeatures/premiumFeatures'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { usePremiumFeaturesPermissions } from '@/stores/permissions/premiumFeatures'
import { useFlag } from '@unleash/proxy-client-react'
import { useMemo } from 'react'

export function useMarketIntelligencePermissions() {
  const marketIntelligenceFlag = useFlag(DashboardExperiments.showMarketIntelligence)

  const marketIntelligencePermission = useCorePermissions(CoreLevelFeatureNames.marketIntelligence)
  const hasMarketIntelligencePermission = useMemo(() => {
    return !marketIntelligencePermission?.hide
  }, [marketIntelligencePermission])

  const premiumFeaturesPermissions = usePremiumFeaturesPermissions()
  const hasMarketIntelligenceFeature = premiumFeaturesPermissions.includes(
    PremiumFeatures.MarketIntelligence,
  )

  const shouldShowMarketIntelligencePages =
    marketIntelligenceFlag && hasMarketIntelligenceFeature && hasMarketIntelligencePermission

  return useMemo(
    () => ({
      shouldShowMarketIntelligencePages,
    }),
    [shouldShowMarketIntelligencePages],
  )
}
